import React, { useState, useEffect }  from 'react';
import Navbar from "../components/Navbar";
import HeroCarousel from "../components/HeroCarousel";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import './Acasa.css';
import { RiCustomerService2Line } from "react-icons/ri";
import { LiaShippingFastSolid } from "react-icons/lia";
import { CiStar } from "react-icons/ci";
import { FaCheck } from "react-icons/fa6";
import riflaje from '../assests/riflaj perete superficial.jpg';
import riflajemoderne from '../assests/riflaj perete mobila Bucuresti sector 2.jpg';
import dormitorbucuresti from '../assests/dormitor.jpg';
import dormitorsector2 from '../assests/dormitor verde.jpg';
import bucatariebucuresti from '../assests/bucatarie moderna spatioasa.jpg'
import bucatarie from '../assests/Bucatarie moderna Bucuresti sector 2.jpg'
import bucatariesector2 from '../assests/Bucatarie moderna Bucuresti sector 2.jpg'
import sufragerie from '../assests/sufragerie model gri.jpg'
import dulap from '../assests/dulap usa cu geam glisabila.jpg'
import ScrollTextSection from "../components/ScrollTextSection";
import '../components/ScrollTextSection.css'
import dormitorverde from '../assests/sufragerie model gri.jpg'
// SEO Google
import { Helmet } from "react-helmet";


// SEO Google


import chairsImage from '../assests/picture 1.jpg';
import tablesImage from '../assests/picture 2.jpg';
import storageImage from '../assests/picture 3.jpg';

const features = [
  {
    icon: <RiCustomerService2Line />,
    title: "Service clienti",
    description: "Suna acum",
  },
  {
    icon: <LiaShippingFastSolid />,
    title: "Transport",
    description: "Transportul variaza in functie de comanda",
  },
  {
    icon: <CiStar />,
    title: "Nota pe Google 4.8",
    description: "Trustpilot",
  },
  {
    icon: <FaCheck />,
    title: "Garantie inclusa",
    description: "Pentru toate produsele",
  },
];

const FeatureSection = () => (
  <section className="feature-section">
    {features.map((feature, index) => (
      <div className="feature" key={index}>
        <div className="icon">{feature.icon}</div>
        <h3>{feature.title}</h3>
        <p>{feature.description}</p>
      </div>
    ))}
  </section>
);

function Acasa() {
 const navigate = useNavigate(); 
  // hero section
  const [currentSlide, setCurrentSlide] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  
    // Sample images - înlocuiește cu imaginile tale
    const slides = [
      {
        id: 1,
        image: "https://images.pexels.com/photos/1643384/pexels-photo-1643384.jpeg",
        title: "Mobilă pe gustul tău",
        subtitle: "Arta mobilierului perfect",
        buttonText: "Afla mai multe!",
        link: "/servicii-mobila-la-comanda-sector-2"
      },
      {
        id: 2,
        image:"https://images.pexels.com/photos/8089188/pexels-photo-8089188.jpeg",
        title: "Modern și cu stil", 
        subtitle: "Eleganță",
        buttonText: "Exploreaza colectia",
        link: "/proiecte-mobila-sector-2-bucuresti"
      },
      {
        id: 3,
        image: "https://images.pexels.com/photos/6489092/pexels-photo-6489092.jpeg",
        title: "Eleganță la tine acasă",
        subtitle: "Contemporan",
        buttonText: "Vezi mai mult!",
        link: "/catalog-mobila-bucuresti"
      }
    ];
  
    // Auto-scroll functionality
    useEffect(() => {
      if (!isAutoPlaying) return;
  
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 5000); // 5 seconds
  
      return () => clearInterval(interval);
    }, [isAutoPlaying, slides.length]);
  
    const nextSlide = () => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
      setIsAutoPlaying(false);
      // Resume auto-play after 10 seconds
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };
  
    const prevSlide = () => {
      setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
      setIsAutoPlaying(false);
      // Resume auto-play after 10 seconds
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };
  
    const goToSlide = (index) => {
      setCurrentSlide(index);
      setIsAutoPlaying(false);
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };
    // hero section
  
  // ✅ useState și switchImage sunt aici, în aceeași funcție
  const [activeImages, setActiveImages] = useState({
    riflaje: riflaje,
    riflaje1: riflajemoderne,
    dormitor: dormitorbucuresti,
    dormitor1: dormitorsector2,
    bucatarie: bucatarie,
    bucatarie1: bucatariebucuresti,
    bucatarie2: bucatariesector2,
    sufragerie: sufragerie,
    dulap: dulap,
    chairs: chairsImage,
    tables: tablesImage,
    storage: storageImage
  });

   const switchImage = (category) => {
    const newImages = { ...activeImages };
    switch (category) {
      case 'riflaje':
        newImages.riflaje = newImages.riflaje === riflaje ? riflajemoderne : riflaje;
        break;
      case 'dormitor':
        newImages.dormitor = newImages.dormitor === dormitorbucuresti ? dormitorsector2 : dormitorbucuresti;
        break;
      case 'bucatarie':
        if (newImages.bucatarie === bucatarie) {
          newImages.bucatarie = bucatariebucuresti;
        } else if (newImages.bucatarie === bucatariebucuresti) {
          newImages.bucatarie = bucatariesector2;
        } else {
          newImages.bucatarie = bucatarie;
        }
        break;
      case 'sufragerie':
        // Dacă ai mai multe imagini pentru sufragerie, adaugă logica de schimbare
        break;
      case 'dulap':
        // Dacă ai mai multe imagini pentru dulap, adaugă logica de schimbare
        break;
      case 'chairs':
        newImages.chairs = newImages.chairs === chairsImage ? tablesImage : chairsImage;
        break;
      case 'tables':
        newImages.tables = newImages.tables === tablesImage ? storageImage : tablesImage;
        break;
      case 'storage':
        newImages.storage = newImages.storage === storageImage ? chairsImage : storageImage;
        break;
      default:
        break;
    }
    setActiveImages(newImages);
  };

  return (
    <div>
      <Helmet>
        <title>Mobila Sector 2 București - Mobilier la comandă</title>
        <meta name="description" content="Mobila la comandă în Sector 2 București. Proiecte personalizate pentru casa și biroul tău." />
        <meta name="keywords" content="mobila București, mobila sector 2, mobilier la comandă, proiecte mobila, mobila modernă" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Mobila Sector 2 București - Mobilier la comandă" />
        <meta property="og:description" content="Proiecte personalizate de mobilă pentru casa și biroul tău, în Sector 2 București." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mobila-bucuresti-sector-2.ro/" />
        <meta property="og:image" content="%PUBLIC_URL%/bucuresti-mobila-sector-2.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mobila Sector 2 București - Mobilier la comandă" />
        <meta name="twitter:description" content="Proiecte personalizate de mobilă pentru casa și biroul tău, în Sector 2 București." />
        <meta name="twitter:image" content="%PUBLIC_URL%/bucuresti-mobila-sector-2.png" />
      </Helmet>
      <Navbar />
      <HeroCarousel />
      <FeatureSection />
      {/* Sectiune layout */}
      <div className="series-section">
        <div className="series-header">
          <h2>Categorii de produse</h2>
        </div>
        <div className="series-categories">
          <div className="category" onClick={() => switchImage('riflaje')}>
            <div className="image-container">
              <img src={activeImages.riflaje} alt="Riflaje" />
            </div>
            <h3>Riflaje</h3>
          </div>

          <div className="category" onClick={() => switchImage('dormitor')}>
            <div className="image-container">
              <img src={activeImages.dormitor} alt="Dormitor" />
            </div>
            <h3>Dormitor</h3>
          </div>

          <div className="category" onClick={() => switchImage('bucatarie')}>
            <div className="image-container">
              <img src={activeImages.bucatarie} alt="Bucătărie" />
            </div>
            <h3>Bucătărie</h3>
          </div>

          <div className="category" onClick={() => switchImage('sufragerie')}>
            <div className="image-container">
              <img src={activeImages.sufragerie} alt="Sufragerie" />
            </div>
            <h3>Sufragerie</h3>
          </div>

          <div className="category" onClick={() => switchImage('dulap')}>
            <div className="image-container">
              <img src={activeImages.dulap} alt="Dulap" />
            </div>
            <h3>Dulap</h3>
          </div>
        </div>
      </div>
      {/* Sectiune layout */}

 <section className="furniture-hero1">
      <div className="hero-container1">
        <div className="hero-content1">
          <div className="hero-text1">
            <h1 style={{marginTop:'0px'}} className="hero-title1">
              Experiența noastră aduce mobilierul de vis la tine acasă
            </h1>
            <p className="hero-description1">
              Mobilier la comandă cu tradiție - La Mobila Sector 2, transformăm ideile 
              clienților în mobilier personalizat, de calitate superioară.
            </p>
            <p className="hero-details1">
              Cu peste 20 de ani de experiență, materiale 
              premium, execuție impecabilă și montaj profesionist. Mobilă la comandă 
              pentru bucătării, livinguri, dormitoare, dressing-uri și spații comerciale - în 
              București și în toată țara.
            </p>
          </div>

          <div className="features-grid">
          </div>
        </div>

        <div className="hero-image">
          <img src={dormitorverde} alt="" srcset="" />
        </div>
      </div>
    </section>

      {/* Hero section */}
       <section className="hero-carousel">
      <div className="carousel-container">
        {/* Slides */}
        <div className="slides-wrapper">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${slide.image})`,
                transform: `translateX(${(index - currentSlide) * 100}%)`
              }}
            >
              <div style={{pointerEvents:'none'}} className="slide-overlay"></div>
              <div className="slide-content">
                <h1 className="slide-title">{slide.title}</h1>
                <p className="slide-subtitle">{slide.subtitle}</p>
                 <button 
  className="slide-button"
  onClick={() => {
    console.log("Buton apăsat, merg spre:", slide.link);
    try {
      navigate(slide.link);
    } catch (error) {
      console.error("Eroare la navigare:", error);
    }
  }}
>
          {slide.buttonText}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </button>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button 
          className="carousel-arrow carousel-arrow-left" 
          onClick={prevSlide}
          aria-label="Previous slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m15 18-6-6 6-6"/>
          </svg>
        </button>

        <button 
          className="carousel-arrow carousel-arrow-right" 
          onClick={nextSlide}
          aria-label="Next slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </button>

        {/* Dots Indicator */}
        <div className="carousel-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Progress Bar */}
        <div className="carousel-progress">
          <div 
            className="progress-bar"
            style={{
              animationDuration: isAutoPlaying ? '5s' : '0s',
              animationPlayState: isAutoPlaying ? 'running' : 'paused'
            }}
            key={currentSlide} // Reset animation on slide change
          />
        </div>
      </div>
    </section>
    <ScrollTextSection />
    {/* Hero section */}
      {/* <div style={{ padding: '2rem', minHeight: '50vh' }}>
        <h2 style={{ textAlign: 'center', margin: '2rem 0' }}>
          Restul conținutului paginii...
        </h2>
      </div> */}

      <Footer />
    </div>
  );
}

export default Acasa;
